import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SchoolModule } from '../../../appshared/Main/school/school.module';
import { SchoolService } from '../../../appshared/Main/school/school.service';

@Component({
  selector: 'app-register-qutuf-terms',
  templateUrl: './register-qutuf-terms.component.html',
  styleUrls: ['./register-qutuf-terms.component.scss']
})
export class RegisterQutufTermsComponent implements OnInit {

    isLoading = true;
    constructor(private router: Router) { }

    ngOnInit(): void {
    }


    public onClickBT() {

        this.router.navigate(['register_qutuf_details']);

    }
}
